module.exports = __webpack_public_path__ + "img/icon_clock.2b3ee223.png";